<template>
  <nav>
    <h2 class="a11y-hidden">메뉴 네비게이션</h2>
    <ul class="sub-list" >
      <li v-for="(menu, index) in menuItemList" :key="'mainMenuItem_' + index" :data-index="menu.index" @click.prevent="()=>clickMenuItem(index)">
        <a href="#" :class="menu.routeName === $route.name ? 'on' : ''" :data-index="menu.index">{{menu.title}}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { get } from 'lodash'
import { PATH_NAME_CUSTOMER_USER_QNA, PATH_NAME_FAQ, PATH_NAME_NOTICE_LIST } from '@/common/router.const'
export default {
  name: 'CustomerMainMenu',
  props: ['menuIndex', 'changeMenuFn'],
  data () {
    return {
      menuItemList: [
        { index: 0, title: 'FAQ', path: `/customer/faq`, routeName: PATH_NAME_FAQ },
        { index: 1, title: '공지사항', path: `/customer/notice_list`, routeName: PATH_NAME_NOTICE_LIST },
        { index: 2, title: '1:1 문의', path: '/customer/user_qna', routeName: PATH_NAME_CUSTOMER_USER_QNA }
      ]
    }
  },
  methods: {
    clickMenuItem (index) {
      const clickMenuItem = get(this.menuItemList.filter((menu) => { return menu.index === +index }), ['0'], {})
      this.changeMenuFn(clickMenuItem)
    }
  }
}
</script>
